import React from 'react';
import { useRealtime } from '@/context/RealtimeContext';
import { cn } from '@/lib/utils';

export const RealtimePill = () => {
  const { connected } = useRealtime();
  return (
    <div
      data-testid="realtime-status-pill"
      className={cn(
        'inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-medium',
        connected ? 'border-[#BBF7D0] bg-[#F0FDF4] text-[#15803D]' : 'border-border bg-muted text-muted-foreground'
      )}
      title={connected ? 'Connesso al server (real-time)' : 'Riconnessione...'}
    >
      <span className="relative flex h-2 w-2">
        {connected && (
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#86EFAC] opacity-75" />
        )}
        <span className={cn('relative inline-flex h-2 w-2 rounded-full', connected ? 'bg-[#22C55E]' : 'bg-muted-foreground')} />
      </span>
      {connected ? 'Live' : 'Offline'}
    </div>
  );
};
